__turbopack_context__.v({
  "collapsibleSection": "Collapsiblelnterlinking-module__3Y7laW__collapsibleSection",
  "collapsibleSectionContent": "Collapsiblelnterlinking-module__3Y7laW__collapsibleSectionContent",
  "container": "Collapsiblelnterlinking-module__3Y7laW__container",
  "ctas": "Collapsiblelnterlinking-module__3Y7laW__ctas",
  "section": "Collapsiblelnterlinking-module__3Y7laW__section",
  "sectionHeading": "Collapsiblelnterlinking-module__3Y7laW__sectionHeading",
  "sections": "Collapsiblelnterlinking-module__3Y7laW__sections",
  "title": "Collapsiblelnterlinking-module__3Y7laW__title",
  "viewMoreButton": "Collapsiblelnterlinking-module__3Y7laW__viewMoreButton",
});
